import {
  POSTER_OPEN,
  USER_LOGIN_REFRESH_SUCCESS,
  USER_LOGIN_SUCCESS,
  USER_LOGOUT,
  USER_PAN,
  ENACH_UMR,
  ENACH_FOLIO,
  ENACH_BANK_ACC,
  ENACH_START_DATE,
  ENACH_END_DATE,
  ENACH_MAX_AMOUNT,
} from "../types/auth";
import {
  GET_INVESTOR_DETAILS,
  GET_INVESTOR_DETAILS_SUCCESS,
  GET_CAMS_DATA_SUCCESS,
  REMOVE_CAMS_DATA,
  STORE_EMPANEL_DATA,
  STORE_BANK_DETAILS,
  STORE_BASIC_DETAILS,
  STORE_NOMINEE_DETAILS,
  STORE_BANK_STATE,
  STORE_CAMS_DETAILS,
  STORE_EMPANELLEMENT_NOMINEE_DETAILS
} from "../types";

const initialState = {
  token: null,
  showAll: false,
  lastLogin: "",
  user_pan: "",
  tran_enable_flag: "",
  auth_token: null,
  posterStatus: 0,
  umr: "",
  enachFolio: "",
  enachBank: "",
  camsdata: [],
  storeCAMSData:{},
  storeempanelmentNomineeDetails:{},
  empanelmentNomineeDetails:{},
  empanelmentBasicDetails: {},
  empanelmentBankDetails: {},
  bankState: {},
};

export function authReducer(state = initialState, action) {
  switch (action.type) {
    case USER_LOGIN_SUCCESS: {
      const { DtData, Dtinformation, token } = action.body;

      const [data] = DtData;
      const { ARNCode, Login_MailID, Regflag } = data;
      return {
        ...state,
        auth_token: token,
        token: ARNCode,
        userId: Login_MailID,
        lastLogin: Dtinformation[0].last_login,
        tran_enable_flag: DtData[0].tran_enable_flag,
        Regflag,
      };
    }
    case STORE_CAMS_DETAILS: {
      return {
        ...state,
        storeCAMSData: action.body,
      };
    }
    case STORE_EMPANELLEMENT_NOMINEE_DETAILS: {
      return {
        ...state,
        storeempanelmentNomineeDetails: action.body,
      };
    }
    case STORE_BASIC_DETAILS: {
      return {
        ...state,
        empanelmentBasicDetails: action.body,
      };
    }
    case STORE_BANK_DETAILS: {
      return {
        ...state,
        empanelmentBankDetails: action.body,
      };
    }
    case STORE_NOMINEE_DETAILS: {
      return {
        ...state,
        empanelmentNomineeDetails: action.body,
      };
    }
    case STORE_BANK_STATE: {
      return {
        ...state,
        bankState: action.body,
      };
    }
    case GET_CAMS_DATA_SUCCESS: {
      const { DtData } = action.body;
      return {
        ...state,
        camsdata: DtData,
      };
    }
    case REMOVE_CAMS_DATA: {
      return {
        ...state,
        camsdata: [],
      };
    }
    case USER_LOGIN_REFRESH_SUCCESS: {
      return {
        ...state,
        auth_token: action.body.token,
      };
    }
    case POSTER_OPEN: {
      return {
        ...state,
        posterStatus: action.body,
      };
    }

    case GET_INVESTOR_DETAILS: {
      return {
        ...state,
        investorData: {},
        showAll: false,
        communicationDetails: [],
        bankDetails: [],
        fundList: [],
      };
    }
    case GET_INVESTOR_DETAILS_SUCCESS: {
      const {
        Table14: communicationDetails,
        Table7: bankDetails,
        Table11,
        Table14: fundList,
      } = action.body;
      const showTotalCards =
        !!fundList && fundList.find((ele) => !!ele.Fund && ele.Fund === "189");
      const [investorData] = Table11;
      return {
        ...state,
        showAll: !!showTotalCards ? true : false,
        investorData,
        communicationDetails,
        bankDetails,
        fundList,
      };
    }
    case USER_LOGOUT: {
      return initialState;
    }
    case USER_PAN: {
      return {
        ...state,
        user_pan: action.body,
      };
    }
    case ENACH_UMR: {
      return {
        ...state,
        umr: action.body,
      };
    }

    case ENACH_FOLIO: {
      return {
        ...state,
        enachFolio: action.body,
      };
    }
    case ENACH_BANK_ACC: {
      return {
        ...state,
        enachBank: action.body,
      };
    }
    case ENACH_START_DATE: {
      return {
        ...state,
        enachStartDate: action.body,
      };
    }
    case ENACH_END_DATE: {
      return {
        ...state,
        enachEndDate: action.body,
      };
    }
    case ENACH_MAX_AMOUNT: {
      return {
        ...state,
        enachMaxAmount: action.body,
      };
    }
    default:
      return state;
  }
}
